import { Chapter, Reveal } from "@/components/site/Reveal";

const PHOTOS = [
    {
        url: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/5w0rgxt7_40.jpeg",
        caption: "Poolside turf · Treasure Valley",
        span: "md:col-span-7",
        ratio: "md:aspect-[16/10]",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/cnf7nfet_52.jpeg",
        caption: "Custom 4-hole green with firepit",
        span: "md:col-span-5",
        ratio: "md:aspect-[16/10]",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/coj2kioo_43.jpeg",
        caption: "Front-yard install · seamless edge",
        span: "md:col-span-5",
        ratio: "md:aspect-[16/10]",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/f6bijx28_IMG_1437.jpeg",
        caption: "Backyard play area + in-ground trampoline",
        span: "md:col-span-7",
        ratio: "md:aspect-[16/10]",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/pdqcysro_IMG_1222.jpeg",
        caption: "Shaded front-yard putting green",
        span: "md:col-span-12",
        ratio: "md:aspect-[21/9]",
    },
];

export const Gallery = () => {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative border-t border-brand-border/60 bg-white py-24 md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <Chapter
                    index="04"
                    label="Recent work"
                    testid="gallery-chapter"
                    title={
                        <>
                            A few installs from{" "}
                            <span className="italic text-brand-accent">around the Valley</span>.
                        </>
                    }
                    copy="Real yards, real customers, real Idaho weather. Every job custom-shaped, hand-laid, and infilled to last."
                />

                <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
                    {PHOTOS.map((p, i) => (
                        <Reveal key={p.url} delay={i * 0.05} className={p.span}>
                            <figure
                                data-testid={`gallery-item-${i}`}
                                className="spotlight group relative overflow-hidden rounded-3xl border border-brand-border bg-white transition-colors duration-500 hover:border-brand-accent/40"
                            >
                                <div className={`relative aspect-[4/3] overflow-hidden ${p.ratio}`}>
                                    <img
                                        src={p.url}
                                        alt={p.caption}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
                                    <span className="font-display absolute right-5 top-4 text-3xl font-light italic text-white/50">
                                        0{i + 1}
                                    </span>
                                    <figcaption className="absolute inset-x-0 bottom-0 p-6">
                                        <span className="inline-flex items-center rounded-full border border-white/15 bg-black/50 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                                            {p.caption}
                                        </span>
                                    </figcaption>
                                </div>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
